<section class="container">
  <div>
    <div fxLayout="row wrap" class="search-area" fxLayoutAlign="space-between start"></div>
    <div *ngIf="modules.includes(modulePermission.VisualizarEmpresas)" class="table">
      <div class="container-header">
        <mat-form-field appearance="outline" color="accent">
          <input type="text" [placeholder]="'settings.company-management.search-importer' | translate" matInput [formControl]="inputSearch" autocomplete="off" />
        </mat-form-field>

        <button *ngIf="modules.includes(modulePermission.SolicitarNovaEmpresa)" mat-flat-button color="accent" class="button-new-company" (click)="openDialogNewCompany()">
          <mat-icon> add </mat-icon>
          {{ ('settings.company-management.add' | translate).toUpperCase() }}
        </button>
      </div>
      <table mat-table [dataSource]="dataSource" matSort #empTbSort="matSort" class="example-table table unset-color">
        <ng-container matColumnDef="favorite">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'settings.companies.favorite' | translate }}</th>
          <td mat-cell *matCellDef="let element" class="padding-right">
            <mat-icon (click)="favoriteCompany(element, false)" class="start" *ngIf="element.favorite"> star </mat-icon>
            <mat-icon (click)="favoriteCompany(element, true)" class="not-favorite start" *ngIf="!element.favorite"> star </mat-icon>
          </td>
        </ng-container>

        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>#ID</th>
          <td mat-cell *matCellDef="let element" class="padding-right">
            {{ element.id }}
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'settings.companies.company-name' | translate }}
          </th>
          <td mat-cell matTooltip="{{ element.name }}" *matCellDef="let element" class="padding-right">
            {{ element.name | truncate : 30 }}
          </td>
        </ng-container>

        <ng-container matColumnDef="street">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'settings.companies.street' | translate }}
          </th>
          <td mat-cell *matCellDef="let element" class="padding-right">
            {{ element?.street | translate }}
          </td>
        </ng-container>

        <ng-container matColumnDef="idCountry">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'settings.companies.country' | translate }}
          </th>
          <td mat-cell *matCellDef="let element" class="padding-right">
            <mat-select-country class="select-country" [value]="element.country" appearance="standard" label=" " readonly="true"> </mat-select-country>
          </td>
        </ng-container>

        <ng-container matColumnDef="poBox">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'settings.companies.poBox' | translate }}
          </th>
          <td mat-cell *matCellDef="let element" class="padding-right">
            {{ element?.poBox | translate }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'settings.companies.actions' | translate }}
          </th>

          <td mat-cell *matCellDef="let element">
            <button mat-button [matMenuTriggerFor]="menu"><mat-icon> more_vert </mat-icon></button>
            <mat-menu #menu="matMenu">
              <div class="container-actions">
                <button class="actions-btn" (click)="openDialogNewCompany(element)" mat-icon-button>
                  <mat-icon> create </mat-icon>
                  <span>{{ 'settings.companies.edit' | translate }}</span>
                </button>
                <button class="actions-btn" (click)="removeCompany(element)" mat-icon-button>
                  <mat-icon> delete </mat-icon>
                  <span>{{ 'settings.companies.delete' | translate }}</span>
                </button>
              </div>
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <mat-paginator
        class="unset-color"
        #paginator
        [length]="count"
        [pageSizeOptions]="[5, 10, 25, 100]"
        [pageIndex]="pageIndex"
        [pageSize]="query?.PageSize"
        showFirstLastButtons
        (page)="filterPage($event)"
      >
      </mat-paginator>
    </div>
  </div>
</section>
